import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../services/app-settings.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'dk-doc-viewer-manager',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './doc-viewer-manager.component.html',
  styleUrls: ['./doc-viewer-manager.component.scss'],
})
export class DocViewerManagerComponent implements OnInit,OnChanges {
  useDocViewer = environment.useDocViewer;
  @Input() url: SafeResourceUrl; //for non-docviewer
  @Input() isFileImage:boolean=false;//for non-docviewer
  @Input() failedDocMessage:string;//for non-docviewer
  @Input() documentLoad:boolean;//for non-docviewer
  @Output() loadingDone :EventEmitter<boolean>=new EventEmitter<boolean>();

  /** DKM-5138 Cedric: resim ön izlemesinde yakınlaştırma araç çubuğu (opt-in; varsayılan kapalı, yalnız Arşiv ekranlarında açık). */
  @Input() yakinlastirma = false;
  zoom = 100;
  /** DKM-5164 Cedric: html/txt belge (Saysis üst yazıları) → kum havuzlu (sandbox) iframe'de açılır: script, form,
   *  açılır pencere ve uygulamanın kökenine (oturum/token) erişim kapalı. Opt-in; varsayılan kapalı (diğer ekranlar eskisi gibi). */
  @Input() guvenliHtml = false;
  readonly zoomMin = 25;
  readonly zoomMax = 400;

  @Input() docId: number; //for doc-viewer
  @Input() width: number=770; //for doc-viewer
  @Input() height: number; //for doc-viewer

  docViewerUrl: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {}


  ngOnChanges(changes: SimpleChanges): void {
   if(changes["url"]) this.zoom = 100; // DKM-5138 Cedric: yeni belgede yakınlaştırma sıfırlanır
   if(changes["docId"]){
    let url = `${environment.docViewerUrl}Document?DocId=${this.docId}`;
    if (this.width) url += `&Width=${this.width}`;
    if (this.height) url += `&Height=${this.height}`;
    this.loadingDone.emit(false);
    this.docViewerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
   }
  }


  ngOnInit(): void {
    console.log(this.useDocViewer)
    console.log(this.isFileImage)
    if (this.useDocViewer) {
      let url = `${environment.docViewerUrl}Document?DocId=${this.docId}`;
      if (this.width) url += `&Width=${this.width}`;
      if (this.height) url += `&Height=${this.height}`;
      this.loadingDone.emit(false);
      this.docViewerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }


  }

  
  /** DKM-5138 Cedric: yakınlaştırma adımı (+25 / -25); 100 = sığdır. */
  @ViewChild('zoomAlan') zoomAlan: ElementRef<HTMLDivElement>;

  zoomDegistir(adim: number) {
    // görünen alanın ortası yakınlaştırmadan sonra da ortada kalsın
    const el = this.zoomAlan?.nativeElement;
    const ox = el && el.scrollWidth ? (el.scrollLeft + el.clientWidth / 2) / el.scrollWidth : 0.5;
    const oy = el && el.scrollHeight ? (el.scrollTop + el.clientHeight / 2) / el.scrollHeight : 0;
    this.zoom = Math.min(this.zoomMax, Math.max(this.zoomMin, this.zoom + adim));
    if (el) setTimeout(() => {
      el.scrollLeft = ox * el.scrollWidth - el.clientWidth / 2;
      el.scrollTop = oy * el.scrollHeight - el.clientHeight / 2;
    });
  }

  /** DKM-5138 Cedric: Ctrl + fare tekerleği ile yakınlaştırma (Ctrl'siz tekerlek kaydırır). */
  tekerlek(e: WheelEvent) {
    if (!e.ctrlKey) return;
    e.preventDefault();
    this.zoomDegistir(e.deltaY < 0 ? 25 : -25);
  }

  onFileError() {
    this.documentLoad = false;
    this.loadingDone.emit(false);
  }

  onDocumentLoad() {
    this.documentLoad = true;
    this.loadingDone.emit(false);
  }


}
